import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPNNScheduleLookup extends Layout {
    sourcePnnSchedule: DataSource;
    tablePNNSchedule: Table;
}
